// Presentation-only constants — not stored in DB
const MARKETPLACE_LOGOS: Record<string, string> = {
  AMAZON: "/brands/amazon.svg",
  EBAY: "/brands/ebay.svg",
  COUPANG: "/brands/coupang.svg",
  NOON: "/brands/noon.svg",
  WISH: "/brands/wish.svg",
  SHOPCLUES: "/brands/shopclues.svg",
  SHOPIFY: "/brands/shopify.svg",
  "11STREET": "/brands/11street.svg",
  FLIPKART: "/brands/flipkart.svg",
  MEESHO: "/brands/meesho.svg",
  SNAPDEAL: "/brands/snapdeal.svg",
};

/** Accepts a code (`AMAZON`) or display name (`Amazon`, `ShopClues`); "" when unknown. */
export function marketplaceLogo(marketplace: string): string {
  return MARKETPLACE_LOGOS[marketplace.toUpperCase()] ?? "";
}
